
import { useNavigate } from "react-router-dom";
import styles from "./PrintMedList.module.css";
import { Table } from "antd";
import { useTranslation } from "react-i18next";

const FacilitiesRedirect = ({
  facilities,
  selectedSiteIndex,
  dispensingOrder,
}) => {
  const { t } = useTranslation("medList");
  const navigate = useNavigate()
  
  const columns = [
    {
      title: t("facilityLabel"),
      dataIndex: "name",
      align: "center",
    },
    {
      title: t("errorLabel"),
      align: "center",
      render: (_, record) => ( 
        t(record.validationError)
      )
    },
    {
      title: t("actionLabel"),
      key: 'action',
      align: "center",
      render: (_, record) => ( 
        <button
          onClick={() => {
            navigate("/settings/facilities/create", {
              state: {
                facility: record,
                previousPath: "/dispensing-orders",
                previousState: {
                  selectedSiteIndex,
                  dispensingOrder,
                }
              }
            });
          }}
          className={styles.PrintMedList__buttonLink}
        >
          {t("editFacilityButton")}
        </button>
      ),
    },
  ]

  return (
    <div className={styles.PrintMedList__table}>
      <Table
        rowKey={"_id"}
        dataSource={facilities}
        columns={columns}          
        pagination={
          facilities.length > 10
            ? {
                pageSize: 10,
                total: facilities.length,
              }
            : false
        }
      />
    </div>
  )
}


export default FacilitiesRedirect;